import React, { useState } from "react";
import { Form, Button, Container, Row, Col, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
const API_URL = process.env.REACT_APP_API_URL;

function CreateCategory() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    type: "", // Default value set to DR
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageModalContent, setMessageModalContent] = useState({
    title: "",
    text: "",
    type: "",
    confirmAction: null,
  });

  const showCustomMessageModal = (title, text, type, confirmAction = null) => {
    setMessageModalContent({ title, text, type, confirmAction });
    setShowMessageModal(true);
  };

  const closeCustomMessageModal = () => {
    setShowMessageModal(false);
    setMessageModalContent({
      title: "",
      text: "",
      type: "",
      confirmAction: null,
    });
  };

  const getAuthToken = () => {
    return localStorage.getItem("token");
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
    }
  };

  const validateForm = () => {
    let newErrors = {};
    let isValid = true;
    
    if (!formData.name || !formData.name.trim()) {
      newErrors.name = "Category name is required.";
      isValid = false;
    }
    
    if (!formData.type) {
      newErrors.type = "Category type is required.";
      isValid = false;
    }
    
    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error"
        );
        return;
      }

      // Prepare payload with type field
      const jsonPayload = JSON.stringify({
        name: formData.name.trim(),
        type: formData.type
      });

      const response = await fetch(`${API_URL}/expence-category-create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: jsonPayload,
      });

      if (!response.ok) {
        const errorData = await response.json();
        showCustomMessageModal(
          "Error",
          errorData.message || "Failed to create category.",
          "error"
        );
        return;
      }

      const result = await response.json();

      if (result.success == "1") {
        showCustomMessageModal(
          "Success",
          result.message || "Category created successfully!",
          "success"
        );

        setFormData({ 
          name: "", 
          type: "DR" // Reset to default value
        });
        setErrors({});

        setTimeout(() => {
          navigate("/category-list");
        }, 2000);

      }
      else {
        showCustomMessageModal(
          "Error",
          result.message || "Category creation failed!",
          "error"
        );
      }


    } catch (err) {
      console.error("Error creating category:", err);
      showCustomMessageModal(
        "Error",
        err.message || "An unexpected error occurred.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // return (
  //   <div className="mt-2">
  //     <div className="row">
  //       <div className="col-md-12">
  //         <div className="card">
  //           <div className="card-header">
  //             <div className="d-flex align-items-center justify-content-between">
  //               <div className="titlepage">
  //                 <h3>Create Category</h3>
  //               </div>
  //             </div>
  //           </div>
  //           <div className="card-body">
  //             <Form onSubmit={handleSubmit}>
  //               <Row>
  //                 <Col md={6}>
  //                   <Form.Group className="mb-3">
  //                     <Form.Label htmlFor="categoryName">Category Name</Form.Label>
  //                     <Form.Control
  //                       type="text"
  //                       name="name"
  //                       id="categoryName"
  //                       value={formData.name}
  //                       onChange={handleFormChange}
  //                       placeholder="Enter category name"
  //                       isInvalid={!!errors.name}
  //                     />
  //                     <Form.Control.Feedback type="invalid">
  //                       {errors.name}
  //                     </Form.Control.Feedback>
  //                   </Form.Group>
  //                 </Col>
                  
  //                 <Col md={6}>
  //                   <Form.Group className="mb-3">
  //                     <Form.Label htmlFor="categoryType">Category Type</Form.Label>
  //                     <Form.Select className="text-dark"
  //                       name="type"
  //                       id="categoryType"
  //                       value={formData.type}
  //                       onChange={handleFormChange}
  //                       isInvalid={!!errors.type}
  //                     >
  //                       <option value="">Select Type</option>
  //                       <option value="dr">DR</option>
  //                       <option value="cr">CR</option>
  //                     </Form.Select>
  //                     <Form.Control.Feedback type="invalid">
  //                       {errors.type}
  //                     </Form.Control.Feedback>
  //                   </Form.Group>
  //                 </Col>
                  
  //                 <Col md={12} className="mt-2">
  //                   <Button
  //                     type="submit"
  //                     className="submitbutton_design"
  //                     disabled={loading}
  //                   >
  //                     {loading ? "Creating..." : "Create Category"}
  //                   </Button>
  //                 </Col>
  //               </Row>
  //             </Form>
  //           </div>
  //         </div>
  //       </div>
  //     </div>

  //     {/* Message Modal - Same as before */}
  //     {showMessageModal && (
  //       <div
  //         className="modal d-block"
  //         tabIndex="-1"
  //         style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
  //       >
  //         <div className="modal-dialog modal-dialog-centered">
  //           <div
  //             className={`modal-content ${messageModalContent.type === "success"
  //               ? "border-success"
  //               : messageModalContent.type === "error"
  //                 ? "border-danger"
  //                 : "border-warning"
  //               }`}
  //           >
  //             <div className="modal-header d-flex justify-content-between align-items-center">
  //               <h5
  //                 className={`modal-title ${messageModalContent.type === "success"
  //                   ? "text-success"
  //                   : messageModalContent.type === "error"
  //                     ? "text-danger"
  //                     : "text-warning"
  //                   }`}
  //               >
  //                 {messageModalContent.title}
  //               </h5>
  //               <button
  //                 type="button"
  //                 className="btn-close"
  //                 aria-label="Close"
  //                 onClick={closeCustomMessageModal}
  //               ></button>
  //             </div>
  //             <div className="modal-body text-secondary">
  //               <p>{messageModalContent.text}</p>
  //             </div>
  //             <div className="modal-footer justify-content-center">
  //               {messageModalContent.confirmAction ? (
  //                 <>
  //                   <Button variant="secondary" onClick={closeCustomMessageModal}>
  //                     Cancel
  //                   </Button>
  //                   <Button
  //                     variant={
  //                       messageModalContent.type === "warning" ? "warning" : "primary"
  //                     }
  //                     onClick={() => {
  //                       messageModalContent.confirmAction();
  //                       closeCustomMessageModal();
  //                     }}
  //                   >
  //                     Confirm
  //                   </Button>
  //                 </>
  //               ) : (
  //                 <Button
  //                   variant={
  //                     messageModalContent.type === "success"
  //                       ? "success"
  //                       : messageModalContent.type === "error"
  //                         ? "danger"
  //                         : "primary"
  //                   }
  //                   onClick={closeCustomMessageModal}
  //                 >
  //                   OK
  //                 </Button>
  //               )}
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     )}
  //   </div>
  // );

    return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "30px 24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          {/* 🎯 HEADER CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              padding: "20px 24px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "14px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "24px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              🏷️
            </div>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                Create Category
              </h1>
              <p
                style={{
                  margin: "2px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                Add a new expense category to your account
              </p>
            </div>
          </div>

          {/* 🎯 MAIN CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div style={{ padding: "30px" }}>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="categoryName">
                        Category Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        id="categoryName"
                        value={formData.name}
                        onChange={handleFormChange}
                        placeholder="Enter category name"
                        isInvalid={!!errors.name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="categoryType">
                        Category Type <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        className="text-dark"
                        name="type"
                        id="categoryType"
                        value={formData.type}
                        onChange={handleFormChange}
                        isInvalid={!!errors.type}
                      >
                        <option value="">Select Type</option>
                        <option value="dr">DR</option>
                        <option value="cr">CR</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.type}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Submit Button */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingTop: "20px",
                    borderTop: "1.5px dashed #e2e8f0",
                    marginTop: "10px",
                  }}
                >
                  <button
                    type="submit"
                    disabled={loading}
                    style={{
                      padding: "13px 42px",
                      borderRadius: "12px",
                      border: "none",
                      background: loading
                        ? "#cbd5e1"
                        : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                      color: "#ffffff",
                      fontSize: "14.5px",
                      fontWeight: "800",
                      letterSpacing: "0.5px",
                      cursor: loading ? "not-allowed" : "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: loading
                        ? "none"
                        : "0 8px 24px rgba(30, 87, 153, 0.3)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                      minWidth: "220px",
                    }}
                  >
                    {loading ? (
                      <>
                        <span
                          style={{
                            width: "16px",
                            height: "16px",
                            border: "2px solid rgba(255,255,255,0.3)",
                            borderTop: "2px solid #ffffff",
                            borderRadius: "50%",
                            display: "inline-block",
                            animation: "spin 0.8s linear infinite",
                          }}
                        />
                        Creating...
                      </>
                    ) : (
                      "Create Category"
                    )}
                  </button>
                </div>

                {/* Footer Note */}
                <div
                  style={{
                    marginTop: "20px",
                    paddingTop: "20px",
                    borderTop: "1.5px dashed #e2e8f0",
                    textAlign: "center",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: "12.5px",
                      color: "#94a3b8",
                      fontWeight: "500",
                    }}
                  >
                    🔒 All fields marked with{" "}
                    <span style={{ color: "#dc2626" }}>*</span> are required
                  </p>
                </div>
              </Form>
            </div>
          </div>

          {/* Footer Copyright */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>

      {/* 🎯 MESSAGE MODAL */}
      {showMessageModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className={`modal-content ${
                messageModalContent.type === "success"
                  ? "border-success"
                  : messageModalContent.type === "error"
                    ? "border-danger"
                    : "border-warning"
              }`}
            >
              <div className="modal-header d-flex justify-content-between align-items-center">
                <h5
                  className={`modal-title ${
                    messageModalContent.type === "success"
                      ? "text-success"
                      : messageModalContent.type === "error"
                        ? "text-danger"
                        : "text-warning"
                  }`}
                >
                  {messageModalContent.title}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={closeCustomMessageModal}
                ></button>
              </div>
              <div className="modal-body text-secondary">
                <p>{messageModalContent.text}</p>
              </div>
              <div className="modal-footer justify-content-center">
                {messageModalContent.confirmAction ? (
                  <>
                    <Button
                      variant="secondary"
                      onClick={closeCustomMessageModal}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant={
                        messageModalContent.type === "warning"
                          ? "warning"
                          : "primary"
                      }
                      onClick={() => {
                        messageModalContent.confirmAction();
                        closeCustomMessageModal();
                      }}
                    >
                      Confirm
                    </Button>
                  </>
                ) : (
                  <Button
                    variant={
                      messageModalContent.type === "success"
                        ? "success"
                        : messageModalContent.type === "error"
                          ? "danger"
                          : "primary"
                    }
                    onClick={closeCustomMessageModal}
                  >
                    OK
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
  
}

export default CreateCategory;